import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ActionButton from "./ActionButton";

import { useDispatch, useSelector } from 'react-redux';
import { fetchAuctions } from '../Redux/Auctions/AuctionActions';
import { resetFilter } from "../Redux/Auctions/AuctionsSlice";
import Loader from "./Loader";
import { useTranslate } from "./TranslationText";
import PillBtn from "./PillBtn";
import NewActionButton from "./ActionButtons/NewActionButton";
import { aedLogoStyle, getDirhamImage } from "../common/cssclasses";
import { formatDateTimeToString } from "../helper/formatDateTimeToString";
function formatDate(date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

const BaseURL = process.env.REACT_APP_BASE_URL;




// Component for individual image container
function ImageContainer({ data, index }) {
  const navigation = useNavigate();
  const imageContainerRef = useRef(null);
  const { translate } = useTranslate();
  const { currentLanguage } = useSelector(
    (state) => state.studBookSlice
  );

  return (
    <React.Fragment>
      <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12  mb-main" key={index}>
        <div ref={imageContainerRef} className="bg-white row mx-0 rtl   p-main border-15 p-3 h-100">
          <div className="col-12 px-0 overflow-hidden border-15 mb-form-group" style={{ maxHeight: 150 }}>
            <img
              src={data.eventImageSrc}
              alt={data.eventName}
              className="w-100 "
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `${BaseURL}/assets/img/horseauction.png`;
              }}
            />
          </div>
          <div className="col-12 px-0">
            <div className='showNewTitle'>
              {data.eventName}
            </div>
          </div>
          <div className="col-12 px-0">
            <div className="EventListDivSpacer"></div>
          </div>
          {!!data?.eventDescription
            &&
            <div className="col-12 px-0">
              <div className="horseCardDescription">
                {data?.eventDescription}
              </div>
            </div>}
          <div className="col-12 px-0">
            <div className="row">
              <div className="col-4 w-unset text-start" style={{ fontSize: 13 }}>
                <i
                  className="fa fa-calendar C89C66 me-1"
                  aria-hidden="true"
                ></i>{formatDateTimeToString(data?.eventDate)}
              </div>
              <div className="font-11 col-4 w-unset mx-auto  text-center" style={{ fontSize: 13 }}>
                
                <img src={getDirhamImage(currentLanguage)} alt="AED" style={aedLogoStyle} />
                {data.eventPrice} {translate('web.aed', 'AED')}
              </div>
              <div className="font-11 col-4 w-unset text-end" style={{ fontSize: 13 }}>
                <i
                  className="fa-solid fa-chess-knight C89C66 me-1"
                ></i>
                {data.EventHorses} {translate(`web.horse`, 'Horses')}
              </div>
            </div>
          </div>
          <div className="col-12 px-0 mb-form-group">
            <div className="EventListDivSpacer"></div>
          </div>
          <div className="col-12 px-0" >
            <div className="row">
              <div className="ms-auto  col-xl-6  col-lg-8 col-md-8 col-sm-6 col-12">
                <PillBtn isRed={true} isNoMargin text={translate("web.viewDetails", "View Details")} routeName={`/auction?id=${data?.auctionId}&title=${encodeURIComponent(data?.eventName || '')}`} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default function EventsList({ filters }) {
  // Define the number of containers you want

  const dispatch = useDispatch();
  const auctions = useSelector((state) => state.auctions.auctions);
  const isLoading = useSelector((state) => state.auctions.isLoading);
  const totalCount = useSelector((state) => state.auctions.totalCount);
  const [viewMore, setViewMore] = useState(false);
  const { translate } = useTranslate();


  useEffect(() => {
    setViewMore(false)
    if (filters.reset) {
      dispatch(resetFilter());
    }

    const { reset, ...dataFilters } = filters;
    dispatch(fetchAuctions(dataFilters));
  }, [filters]);

  const handelShowMore = () => {
    setViewMore(true)
    dispatch(fetchAuctions(filters));

  }
  if (isLoading && !viewMore) {
    return <>
      <Loader />
    </>
  }

  return (
    <div className="row rtl">
      {/* Render the specified number of containers */}

      {!!auctions && auctions.length > 0 ? (
        auctions.map((itemData, index) => (
          <ImageContainer key={index} data={itemData} index={index} />
        ))
      ) : (
        <div
          className="col-lg-12 col-md-12 col-sm-12 text-center   EventListDataFoundDiv"
        >
          {translate('web.noAuctionFound', 'No Auction found with Your Filter Parameters')}
        </div>
      )}

      {totalCount > auctions.length && (
        <div className="col-lg-12 col-md-12 col-sm-12 text-center row">

          {!isLoading &&
            <div className="mx-auto w-unset">
              <NewActionButton
                key={'loadMore'}
                onClick={() => handelShowMore()}
                text={translate("web.viewMore", "View More")}
              />
            </div>
          }
          {isLoading && (
            <Loader />
          )}
        </div>
      )}
    </div>
  );
}
